import { render, staticRenderFns } from "./poi-detail-fullscreen-slider.vue?vue&type=template&id=17a748a2&"
import script from "./poi-detail-fullscreen-slider.vue?vue&type=script&lang=ts&"
export * from "./poi-detail-fullscreen-slider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports